import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const StepWrapper = createComponent('div', {
  className: 'z-1 sm:mr-[75px] sm:last:mr-0'
});

export const StepDescription = createComponent('h2', {
  className: cx(
    'relative right-16 top-12 sm:right-0',
    'm-0 w-[136px] sm:w-auto',
    'text-center text-[17px] font-bold leading-[24px] text-blue-6'
  )
});

export const StepContent = createComponent('div', {
  className:
    'flex h-[105px] w-[110px] items-center justify-center rounded-full bg-white'
});

export const StepContentNumber = createComponent('h3', {
  className:
    'relative bottom-[39px] left-4 float-left mb-8 h-[26px] w-[30px] rounded-full bg-blue-2 p-4 text-center text-[12px] text-white'
});
